import { ConApartados } from '../ConApartados';
import type { PropsPantalla } from '../tipos';
import { CanalesDeEnvio } from './CanalesDeEnvio';
import { Enviados } from './Enviados';
import { Plantillas } from './Plantillas';
import { Recordatorios } from './Recordatorios';
import '../avisos/avisos.css';

/**
 * «Mensajes» (Comunicación, G128): la barra de apartados que manda el servidor, «Mensajes a clientes»
 * (`mensajes_plantillas`, 5.3), «Recordatorios» (`mensajes_recordatorios`, 5.4) y «Enviados» (`mensajes_enviados`, 5.5;
 * sin cifra, G305) y «Canales de envío» (`mensajes_canales`, 5.8, G562). Cada apartado solo llega con su permiso.
 */
const APARTADOS = { mensajes_plantillas: Plantillas, mensajes_recordatorios: Recordatorios, mensajes_enviados: Enviados, mensajes_canales: CanalesDeEnvio };

export function Mensajes(props: PropsPantalla) {
    return <ConApartados {...props} prefijo="mensajes_" seccion="Mensajes" icono="message-square-text" apartados={APARTADOS} cortas={{ mensajes_plantillas: 'A clientes', mensajes_canales: 'Canales' }} />;
}
